export default {
    namespaced: true,

    prefix: 'geo/',

    state: {
        location: {},
        form: null,
        modal: false,
        guess: false,
        errors: {},
        loadDeliveryDataOnCityChange: false
    },

    getters: {
        cityName: (state) => {
            return state.location.city ? state.location.city.name : 'Не определено';
        },

        hasError: (state) => (key) => {
            return state.errors.hasOwnProperty(key);
        },

        getError: (state, getters) => (key) => {
            return getters.hasError(key) ? state.errors[key] : '';
        },

        deliveryLocation (state) {
            if (!state.location) {
                return {};
            }

            let location = {};

            if (state.location.region) {
                location.region_id = state.location.region.id;
                location.region_name = state.location.region.name;
                location.region_type_short = state.location.region.type_short;
            }

            if (state.location.district) {
                location.district_id = state.location.district.id;
                location.district_name = state.location.district.name;
                location.district_type_short = state.location.district.type_short;
            }

            if (state.location.city) {
                location.city_id = state.location.city.id;
                location.city_name = state.location.city.name;
                location.city_type_short = state.location.city.type_short;
            }

            return location;
        },

        timeZone (state) {
            return state.location && state.location.timezone ? state.location.timezone : null;
        }
    },

    mutations: {
        setLocation (state, location) {
            Vue.set(state, 'location', location);
        },

        setError (state, { key, value }) {
            state.errors[key] = value;
        },

        deleteError (state, key) {
            if (state.errors[key]) {
                delete state.errors[key];
            }
        },

        setRegion (state, region) {
            state.form.region.name = region;
        },

        setCity: (state, city) => {
            state.form.city.name = city;
        },

        loadDeliveryDataOnCityChange: (state) => {
            state.loadDeliveryDataOnCityChange = true;
        },

        showModal (state) {
            state.modal = true;
        },

        hideModal (state) {
            state.modal = false;
        },

        isGuess (state) {
            state.guess = true;
        },

        acceptTheGuess (state) {
            state.guess = false;
        }
    },

    actions: {
        processLocation ({ commit, state }, location) {
            if (_.get(location, 'city.name')) {
                commit('setLocation', location);
                commit('delivery/setLocation', location, { root: true });
            } else {
                axios.get('/location?with_deliveries=true')
                    .then(response => {
                        if (response.data.location) {
                            commit('setLocation', response.data.location);

                            if (response.data.location) {
                                commit('delivery/setLocation', response.data.location, { root: true });
                            }
                            if (response.data.location) {
                                commit('delivery/setDeliveries', response.data.deliveries, { root: true });
                            }
                            if (response.data.pickupPointsCount) {
                                commit('delivery/setPickupPointsCount', response.data.pickupPointsCount, { root: true })
                            }
                            if (response.data.guess) {
                                commit('isGuess');
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
}
